import { BackendLogger } from '../types'

export const backendRegistry: Record<string, BackendLogger> = {}

export const addLogger = (platform: string, logger: BackendLogger) => {
  backendRegistry[platform] = logger
}

export const getBackendLogger = (platform: string): BackendLogger | undefined => backendRegistry[platform]
